module.exports = __webpack_public_path__ + "static/media/Hili Ringel.9304c333.png";